<template>
  <div>
    <a-descriptions bordered size="small" title="关联资产信息">
      <a-descriptions-item label="资产描述">{{ detail.txt50 }}</a-descriptions-item>
      <a-descriptions-item label="资产编号">{{ detail.anln1 }}</a-descriptions-item>
      <a-descriptions-item label="资产分类">
        <span @click="showDetail()" style="cursor: pointer">
          {{ detail.txk20 }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="购置价值">{{ detail.kansw }}</a-descriptions-item>
      <a-descriptions-item label="现值">{{ detail.qmjz }}</a-descriptions-item>
      <a-descriptions-item label="首次购置日期">{{ detail.zugdt }}</a-descriptions-item>
      <a-descriptions-item label="不活动日期">{{ detail.deakt }}</a-descriptions-item>
      <a-descriptions-item label="资产使用年限">{{ detail.ndjar }}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { getAssetDetail } from '@/api/assetLedger'

export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('watch_record', model)
        this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {}
    }
  },
  methods: {
    // 获取业务
    initDetail (model) {
      if (model.assetNumber) {
        const params = {
          anln1: model.assetNumber.slice(0, model.assetNumber.indexOf('-')),
          bukrs: model.subcompanycode,
          anln2: model.assetNumber.slice(model.assetNumber.indexOf('-') + 1, model.assetNumber.length)
        }
        getAssetDetail(params).then(res => {
          if (res.status === 0) {
            this.detail = res.data
          }
        })
      }
    },
    // 跳转至资产详情
    showDetail () {

    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-descriptions{
  margin-bottom: -1px;
  .ant-descriptions-title{
    margin-bottom: 0;
    line-height: 32px;
    font-size: 12px;
    color: #08409F;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    padding: 0 12px;
    border-right: 1px solid #DDDDDD;
    // border-left: 1px solid #e8e8e8;
    background: #FFFFFF;
  }
  .ant-descriptions-view{
    border-radius: 0;
    width: 100%;
    border-color: #DDDDDD;
    // border-left: none;
    // border-right: none;
    .ant-descriptions-row{
      border-bottom: none;
      .ant-descriptions-item-label,
      .ant-descriptions-item-content{
        padding: 8px 12px;
        height: 40px;
        border-bottom: 1px solid #DDDDDD;
        border-color: #DDDDDD;
      }
      .ant-descriptions-item-label{
        background: rgba(8,64,159,0.1);
        width: calc(100% / 9);
      }
      .ant-descriptions-item-content[colspan="1"]{
        // width: 230px;
        width: calc(100% / 9 * 2);
      }
      .ant-descriptions-item-content[colspan="3"]{
        // width: 580px;
        width: calc(100% / 9 * 5);
      }
      .ant-descriptions-item-content[colspan="5"]{
        // width: 930px;
        width: calc(100% / 9 * 8);
      }
    }
    .ant-descriptions-row:last-child{
      .ant-descriptions-item-label,
      .ant-descriptions-item-content{
        // border-bottom: none;
      }
    }

  }
}
/deep/.ant-descriptions:last-child{
  .ant-descriptions-view{
    border-bottom: none;
  }
}
</style>
